import { MDXContent } from './MDXContent';
import { MarkdownContent } from './MarkdownContent';
import { HtmlContent } from './HtmlContent';

interface ContentRendererProps {
  content: string;
  format: 'markdown' | 'mdx' | 'html';
}

export function ContentRenderer({ content, format }: ContentRendererProps) {
  switch (format) {
    case 'mdx':
      return <MDXContent content={content} />;

    case 'markdown':
      return <MarkdownContent content={content} />;

    case 'html':
      // HtmlContent is only used for admin-authored HTML (trusted content)
      return <HtmlContent content={content} />;

    default:
      return <MarkdownContent content={content} />;
  }
}
